import { datadogRum } from '@datadog/browser-rum'

import type { RecipeUUID } from '@library/menu-service'
import { queueTrackingEvent } from '@library/tracking-integration'

type FlexPortionTrackingSource =
  | 'menu_search_screen'
  | 'modal_basket_screen'
  | 'view_recipe_detail_screen'
  | 'view_recipe_list_screen'

export type FlexPortionTrackingContext = {
  menuUuid?: string | null
  recipeUuid: RecipeUUID
  recipePortionCount: number
  basketRecipeCount: number
  source: FlexPortionTrackingSource
}

type FlexPortionTrackingProperties = {
  basket_recipe_count: number
  menu_uuid?: string | null
  recipe_portion_count: number
  recipe_uuid: RecipeUUID
  source: FlexPortionTrackingSource
}

type ClickEditRecipeQuantityEvent = {
  action: 'click_edit_recipe_quantity'
  properties: FlexPortionTrackingProperties
}

type SelectPortionCountEvent = {
  action: 'select_portion_count'
  properties: FlexPortionTrackingProperties
}

type UpdatePortionEvent = {
  action: 'update_portion'
  properties: FlexPortionTrackingProperties
}

const getCommonProperties = (
  context: FlexPortionTrackingContext,
  recipePortionCount = context.recipePortionCount,
): FlexPortionTrackingProperties => ({
  basket_recipe_count: context.basketRecipeCount,
  menu_uuid: context.menuUuid,
  recipe_portion_count: recipePortionCount,
  recipe_uuid: context.recipeUuid,
  source: context.source,
})

export const trackClickEditRecipeQuantity = (context: FlexPortionTrackingContext) => {
  queueTrackingEvent<ClickEditRecipeQuantityEvent>({
    action: 'click_edit_recipe_quantity',
    properties: getCommonProperties(context),
  })
}

export const trackSelectPortionCount = (
  context: FlexPortionTrackingContext,
  recipePortionCount: number,
) => {
  queueTrackingEvent<SelectPortionCountEvent>({
    action: 'select_portion_count',
    properties: getCommonProperties(context, recipePortionCount),
  })
}

export const trackUpdatePortion = (
  context: FlexPortionTrackingContext,
  recipePortionCount: number,
) => {
  datadogRum.addAction('update_recipe_portions_flex', {
    numPortions: recipePortionCount,
    recipeId: context.recipeUuid,
  })

  queueTrackingEvent<UpdatePortionEvent>({
    action: 'update_portion',
    properties: getCommonProperties(context, recipePortionCount),
  })
}
